<template>
<div class="ui middle aligned grid content-view">
  <div class="ui row">
    <DIV class="ui column">
      <CoverPage v-if="!checkpoint"
                  :course="course"></CoverPage>
      <CheckpointView v-else :checkpoint="checkpoint"></CheckpointView>
    </div>
  </div>
</div>
</template>


<script>
import CheckpointView from './CheckpointView.vue';
import CoverPage from './CoverPage.vue';
export default {
  name: 'content-container',
  components: { CheckpointView, CoverPage },
  props: ['course', 'checkpoint']
}
</script>

<style scoped>
.content-view {
height: 100%;
    padding: 5em;
}
</style>



// WEBPACK FOOTER //
// src/components/ContentContainer.vue